<template>
  <div>
    <el-checkbox
      ref="checkAll"
      class="checkAll"
      v-model="isCheckedAll"
      :indeterminate="isIndeterminate"
      @change="changeCheckAll"
      v-if="!isSearch && list && list.length"
    >
      全选
    </el-checkbox>
    <div :style="{ height: divHeight }">
      <dsf-virtual-scroll
        scroll-x
        @scroll="loadMore"
        ref="scrollBar"
        class="scrollBar"
      >
        <ul class="list" ref="list">
          <orgNode
            v-for="item in list"
            :key="item.id"
            :item="item"
            :is-search="isSearch"
          />
        </ul>
        <p class="loading" v-if="loading">
          <i class="el-icon-loading"></i>
        </p>
        <p class="noMore" v-if="noMore">没有更多了</p>
      </dsf-virtual-scroll>
    </div>
  </div>
</template>

<script>
import orgNode from "./orgNode.vue";
export default {
  name: "orgList",
  components: {
    orgNode,
  },
  provide() {
    return {
      $orgList: this,
    };
  },
  inject: {
    $orgBox: {
      default: null,
    },
    $seletPermissions: {
      default: null,
    },
    $orgBoxSearch: {
      default: null,
    }
  },
  props: {
    pid: {
      type: String,
      default: null,
    },
    isRole: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
    searchKeyword: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      list: [],
      loading: false,
      noMore: false,
      isCheckedAll: false,
      listHeight: 0,
      divHeight: "100%",
      params: {
        pid: this.pid,
        keyWord: this.searchKeyword,
        pageNumber: 0, //页码
        pageSize: 10, //每页显示条数
        isExcUser: this.isRole ? 2 : 1,
      },
      checkNum: 0,
      isIndeterminate: false,
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    "$seletPermissions.tabIndex"(n, o) {
      this.getDivHeight();
      this.$orgBox.getListHeight();
      if (
        !this.noMore &&
        this.$el.clientHeight > this.$refs.list.clientHeight
      ) {
        this.loadData();
      }
    },
  },
  methods: {
    getDivHeight() {
      this.divHeight = `calc(100% - ${
        this.$refs?.checkAll?.$el?.clientHeight || 0
      }px)`;
    },
    loadMore(e) {
      let target = e.target;
      if (
        target.scrollHeight - target.clientHeight - target.scrollTop < 20 &&
        !this.loading &&
        !this.noMore
      ) {
        this.loadData();
      }
    },
    loadData() {
      if (
        this.$orgBox.bigObjs[this.params.pid] &&
        !this.params.pageNumber
      ) {
        // 已经加载过的数据
        let { list, pageNumber, noMore } = this.$orgBox.bigObjs[
          this.params.pid
        ];
        if(!this.isRole){
          _.forEach(list,(item) => {
            let config_checked = false,
              config_includeChild = false,
              resultListsIds = _.map(
                this.$seletPermissions.resultLists,
                (item) => {
                  return item.id;
                }
              ),
              resIndex = resultListsIds.indexOf(item.id);
  
            if (resIndex > -1 && !this.isRole) {
              let resItem = this.$seletPermissions.resultLists[resIndex];
              config_checked = true;
              config_includeChild = resItem.config_includeChild;
            }
            item.config_checked = config_checked;
            item.config_includeChild = config_includeChild;
          });
        }
        this.list = list;
        this.params.pageNumber = pageNumber;
        this.noMore = noMore;
        this.$nextTick(() => {
          this.loading = false;
          this.getDivHeight();
        });
      } else {
        this.params.pageNumber++;
        this.loading = true;
        this.$http
          .get("/dp/oua/finOrgByPid", this.params)
          .done(({ data, success, msg }) => {
            if (success) {
              _.forEach(data.list, (item) => {
                let config_checked = false,
                  config_includeChild = false,
                  resultListsIds = _.map(
                    this.$seletPermissions.resultLists,
                    (item) => {
                      return item.id;
                    }
                  ),
                  resIndex = resultListsIds.indexOf(item.id);

                if (resIndex > -1 && !this.isRole) {
                  let resItem = this.$seletPermissions.resultLists[resIndex];
                  config_checked = true;
                  config_includeChild = resItem.config_includeChild;
                }
                this.list.push(
                  dsf.mix(
                    {
                      config_checked: config_checked,
                      config_includeChild: config_includeChild,
                    },
                    item
                  )
                );
                if (resIndex > -1) {
                  // 把引用地址切换成真正的
                  this.$seletPermissions.resultLists.splice(
                    resIndex,
                    1,
                    _.last(this.list)
                  );
                }
              });
              this.noMore = data.lastPage;
            } else {
              this.noMore = true;
              dsf.layer.message(msg, false);
            }
          })
          .error(() => {
            this.noMore = true;
            dsf.layer.message("请求异常", false);
          })
          .always(() => {
            this.$nextTick(() => {
              this.getDivHeight();
              this.loading = false;
              if (
                !this.noMore &&
                this?.$el?.clientHeight > this?.$refs?.list?.clientHeight
              ) {
                this.loadData();
              }
            });
            this.$orgBox.bigObjs[this.params.pid] = {
              list: this.list,
              pageNumber: this.params.pageNumber,
              noMore: this.noMore,
            };
            if (!this.isSearch) {
              if(!this.params.pid && this.list?.[0]){
                this?.$orgBox?.toChild(this.list?.[0]);
              }
            }
          });
      }
    },
    changeCheckState(item) {
      if (item.config_checked) {
        // 选中
        ++this.checkNum;
      } else {
        // 取消选中
        --this.checkNum;
      }
      if (this.checkNum < 0) {
        this.checkNum = 0;
      }
      if (this.list.length == this.checkNum) {
        this.isCheckedAll = true;
        this.isIndeterminate = false;
      } else if (this.checkNum == 0) {
        this.isCheckedAll = false;
        this.isIndeterminate = false;
      } else {
        this.isCheckedAll = false;
        this.isIndeterminate = true;
      }
      if (this.isRole) {
        this.$seletPermissions.changeRoleOrg(item);
      } else {
        this.$seletPermissions.changeResult(item);
      }
      // 无论是新渲染还是被勾选都会执行这里
      if(this.isSearch && this?.$orgBoxSearch?.$refs?.orgBox){
        let list = this?.$orgBoxSearch?.$refs?.orgBox.$refs.orgList.list;
        _.forEach(list,(it)=>{
          if(it.id === item.id){
            it.config_checked = item.config_checked;
          }
        })
      }
    },
    changeCheckAll() {
      _.forEach(this.list, (item) => {
        item.config_checked = this.isCheckedAll;
      });
    },
  },
};
</script>
